import Swiper from '../../../../node_modules/swiper/swiper-bundle.mjs';

export const initAboutSlider = function() {
  const sliderAbout = document.querySelector('[data-slider-about="slider"]');
  if (!sliderAbout) {
    return;
  }

  const swiperAbout = function() {
    new Swiper(sliderAbout, {
      spaceBetween: 12,
      slidesPerView: 'auto',
      loop: false,

      pagination: {
        el: '[data-slider-about=\'pagination\']',
        clickable: true,
        bulletActiveClass: 'is-active',
        bulletClass: 'about-slider__pagination-btn pagination__btn',
        renderBullet(index, className) {
          return '<button class="' + className + '" type="button" aria-label="Перейти на ' + (index + 1) + ' слайд"</button>';
        }
      },
      navigation: {
        nextEl: '[data-slider-about="arrow-next"]',
        prevEl: '[data-slider-about="arrow-prev"]'
      },
      breakpoints: {
        320: {
          spaceBetween: 12,
          // centeredSlides: true,
          slidesPerView: 'auto'
        },
        1500: {
          spaceBetween: 30
        }
      }
    });
  }
  swiperAbout();
};
